export enum DealTypes {
	GuaranteedDeal = 'Guaranteed Deal',
	OpenAuction = 'Open Auction',
	PreferredDeal = 'Preferred Deal',
	PrivateAuction = 'Private Auction',
}

export type DealType = DealTypes.GuaranteedDeal | DealTypes.OpenAuction | DealTypes.PreferredDeal | DealTypes.PrivateAuction;
